import { Component, OnInit } from '@angular/core';
import { ProductService } from './product.service';
import { startWith, delay, tap } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  company = 'Assist 3D';
  title;

  constructor(public productService: ProductService) {
    productService.productName$.pipe(
      startWith(''),
      delay(0),
    ).subscribe((title: string) => {
      this.title = title;
    });
  }

  ngOnInit() {
  }
}
